// research actions
export default {
    update({ state, commit, dispatch, getters }) {
        if (state.items.length == 0 || state.items[0] == undefined) return;

        let item = state.items[0];

        if (getters.isResearched(item.wType.id)) {
            item.time = null;
            dispatch('backpack/addItems', { item: item }, { root: true });
            commit('removeItem', item);
            return
        }



        if (item.time == undefined) {
            item.time = 0;
            item.maxTime = 10;
        } else {
            item.time += 1;
        }


        if (item.time > item.maxTime) {
            dispatch("recipes/addItem", item, { root: true })
            commit('removeItem', item);
        }
    },
    addFromBackpack({ commit }, item) {
        let clone = JSON.parse(JSON.stringify(item));
        clone.time = null;
        clone.uid = clone.id + Date.now();
        clone.amount = null;
        commit('addItem', clone);
        commit('backpack/removeAmount', { item: item, amount: 1 }, { root: true });
    },
    removeToBackpack({ commit, dispatch }, item) {
        item.time = null;
        commit('removeItem', item);
        dispatch('backpack/addItems', { item: item }, { root: true });
    },

}